export const FIND_STATEMENT_TEMPLATE_BY_INDICATOR_ID_REQUEST = 'FIND_STATEMENT_TEMPLATE_BY_INDICATOR_ID_REQUEST';

export const findStatementTemplateByIndicatorIdRequest = ( indicatorId ) => ({
    type: FIND_STATEMENT_TEMPLATE_BY_INDICATOR_ID_REQUEST,
    payload: { indicatorId }
});
